module.exports = __webpack_public_path__ + "static/media/rebirth_7.5d1a5545.jpg";